import { render, staticRenderFns } from "./AllpointsChart.vue?vue&type=template&id=4923467c"
import script from "./AllpointsChart.vue?vue&type=script&lang=js"
export * from "./AllpointsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports